module.exports = __webpack_public_path__ + "static/Aissou-boussad-91ade8af51a3aab049588be498dd35d9.jpg";